var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',{staticClass:"image-wrapper",attrs:{"fluid":""}},[_c('b-jumbotron',{staticClass:"mt-0",class:_vm.hero ? 'hero' : '',attrs:{"fluid":"","text-variant":"white"}},[_c('ImageWithAttribution',{attrs:{"src":_vm.src,"width":_vm.width,"height":_vm.height,"alt":_vm.alt,"content-type":_vm.contentType,"attribution":_vm.attribution}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }